export default {"src":"/_next/static/media/white-square-meters.48a2d7ab.svg","height":2324,"width":2324,"blurWidth":0,"blurHeight":0};